import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import * as API from "../utils/apiPath";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";
import { renderGlobalModal } from "../utils/helpers";

export function loadDataSuccess(menteeRequestData) {
  return {
    type: types.LOADED_MENTEE_REQUEST_DATA,
    menteeRequestData,
  };
}
export function loadWaitListDataSuccess(myWaitListData) {
  return {
    type: types.LOADED_MENTEE_WAITLIST_DATA,
    myWaitListData,
  };
}

export function loadNotFoundDataSuccess(isData) {
  return { type: types.LOADED_DATA_SUCCESS, isData };
}

export const LOAD_STEPS_LABELS_SUCCESS =
  "LOAD_STEPS_LABELS_SUCCESS";

export const loadStepsLabelsSuccess = (data) => ({
  type: LOAD_STEPS_LABELS_SUCCESS,
  payload: data,
});

export function loadpaginationDataSuccess(pagination) {
  return { type: types.LOAD_PAGINATION_DATA_SUCCESS, pagination };
}

export const loadData = (request, status) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.LOAD_MENTEE_REQUEST + "/" + status, {
      params: { ...request, type: "current" },
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};

export const loadRegData = (request, status) => async (dispatch) => {
  try {

    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }

    const response = await agent.get(
      API.LOAD_REG_MENTEE_REQUEST + "/" + status,
      {
        params: {
          ...request,
          type: "current",
        },
      }
    );

    const responseData = response?.data?.data || {};

    const menteeData = responseData?.data || [];
    const pagination = responseData?.pagination || {};
    const stepsLabels = responseData?.steps_labels || {};

    if (menteeData.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }

    dispatch(loadDataSuccess(menteeData));

    dispatch(loadpaginationDataSuccess(pagination));

    // NEW
    dispatch(loadStepsLabelsSuccess(stepsLabels));

    dispatch(toggleNetworkRequestStatus(false));

  } catch (error) {

    renderGlobalModal({
      message: error.message,
    });

    dispatch(toggleNetworkRequestStatus(false));

    dispatch(loadNotFoundDataSuccess(false));
  }
};

export const loadPendingRequestData = (request, status) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(
      API.LOAD_CUSTOMER + "/customerPendingRequest/" + status,
      {
        params: request,
      }
    );
    if (response?.data?.data?.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response?.data?.data?.data) {
      dispatch(loadDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};

export const loadAcceptedMenteesData = (request) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.LOAD_ACCEPTED_MENTEES_DATA, {
      params: request,
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    console.error('Failed to load accepted mentees data:', error);
    renderGlobalModal({
      message: error.message || 'Failed to load accepted mentees data',
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));
  }
};

export const myMentors = (request, userId) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.LOAD_MY_MENTORS + "/" + userId, {
      params: request,
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};
export const myWaitList = (request, userId) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.LOAD_MY_WAITLIST + "/" + userId, {
      params: request,
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadWaitListDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};

export const pendingMentorsRequest = (request, userId) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.PENDING_MENTOR_REQUEST + "/" + userId, {
      params: request,
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadDataSuccess(response.data.data.data));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};

export const pendingRegMentorsRequest = (request, userId) => async (dispatch) => {
  try {
    if (request.short || request.keyword || request.page) {
      dispatch(toggleNetworkRequestStatus(true));
    }
    const response = await agent.get(API.PENDING_REG_MENTOR_REQUEST + "/" + userId, {
      params: request,
    });
    if (response.data.data.data.length <= 0) {
      dispatch(loadNotFoundDataSuccess(false));
    } else {
      dispatch(loadNotFoundDataSuccess(true));
    }
    if (response.data.data.data) {
      dispatch(loadDataSuccess({
        data: response.data.data.data,
        steps_labels:
          response.data.data.steps_labels || {},
      }));
      dispatch(loadpaginationDataSuccess(response.data.data.pagination));
      dispatch(toggleNetworkRequestStatus(false));
    }
  } catch (error) {
    renderGlobalModal({
      message: error.message,
    });
    dispatch(toggleNetworkRequestStatus(false));
    dispatch(loadNotFoundDataSuccess(false));

  }
};

export const sendNotification = (request) => async (dispatch) => {
  dispatch(toggleNetworkRequestStatus(request));
};

export const updateUserReview = (params) => async (dispatch) => {
  try {
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/updateReview",
      params
    );
    dispatch(loadDataSuccess(response.data.data.data));
  } catch (error) {
    // Handle the error appropriately
    console.error('Failed to update user review:', error);
    renderGlobalModal({
      message: error.message || 'Failed to update review',
    });
  }
};

export const updateReason = (params) => async (dispatch) => {
  try {
    dispatch(toggleNetworkRequestStatus(true));
    const response = await agent.post(
      API.LOAD_CUSTOMER + "/updateReason",
      params
    );
    if (response.status === 200) {
      dispatch(toggleNetworkRequestStatus(false));
      dispatch({
        type: "REDIRECT",
        payload: "/my-mentors",
      });
    }
  } catch (error) {
    dispatch(toggleNetworkRequestStatus(false));
    console.error('Failed to update reason:', error);
    renderGlobalModal({
      message: error.message || 'Failed to update reason',
    });
  }
};
